var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app__steps" },
    _vm._l(_vm.maxSteps, function(step) {
      return _c("div", { class: { app__step: true } }, [
        parseInt(_vm.activeStep) >= step
          ? _c("button", {
              class: {
                app__stepDot: true,
                active: step === parseInt(_vm.activeStep)
              },
              on: {
                click: function($event) {
                  return _vm.setStep(step)
                }
              }
            })
          : _c("div", { staticClass: "app__stepDot" })
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }